import { render } from "./areaTeaAgeEchart.vue?vue&type=template&id=4f794788&scoped=true"
import script from "./areaTeaAgeEchart.vue?vue&type=script&lang=js"
export * from "./areaTeaAgeEchart.vue?vue&type=script&lang=js"

import "./areaTeaAgeEchart.vue?vue&type=style&index=0&id=4f794788&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f794788"]])

export default __exports__